<div [formGroup]="parentForm" id="parentForm">
  <div formGroupName="sotkSettings">
    <mat-card class="u-background-color-neutral-0">
      <mat-card-header>
        <mat-card-title>
          <img class="c-global-mat-icon" src="{{hostName}}/assets/images/icon-app-temp-sotk.svg" />
          {{ "SOTK Settings" | moduleDisplayName | async }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content style="text-align: center; padding-left: 40px;">
        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
          <div fxFlex="100" fxFlex.gt-sm="20" fxLayoutAlign="start center">
            {{ "module-assignment.sotk_settings.expected_qty" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="20">
            <mat-checkbox
              id="expectedQuantity"
              formControlName="expectedQuantity"
              (change)="expectedQuantityChecked()"
            >
            </mat-checkbox>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
          <div fxFlex="100" fxFlex.gt-sm="20" fxLayoutAlign="start center">
            {{ "module-assignment.sotk_settings.location" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="20">
            <mat-checkbox
              id="location"
              formControlName="location"
              (change)="expectedQuantityChecked()"
            >
            </mat-checkbox>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
          <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
            {{ "module-assignment.sotk_settings.mod10" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="10">
            <mat-slide-toggle id="mod10" formControlName="mod10"> </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
          <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
            {{ "module-assignment.sotk_settings.mod11" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="10">
            <mat-slide-toggle id="mod11" formControlName="mod11"> </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
          <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
            {{ "module-assignment.sotk_settings.stokCount" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="10">
            <mat-slide-toggle id="stokCount" formControlName="stokCount"> </mat-slide-toggle>
          </div>
        </div>

        <!-- stokMovement configuration -->

        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
          <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
            {{ "module-assignment.sotk_settings.sotkMovement" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="10">
            <mat-slide-toggle
              id="stokMovement"
              formControlName="stokMovementStatus"
              (change)="toggleStokMovementStatus()"
            >
            </mat-slide-toggle>
          </div>
        </div>

        <div [hidden]="isToggleStokMovement">
          <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
            <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
              {{ "module-assignment.sotk_settings.deliveryImport" | translate }}
            </div>
            <div fxFlex="100" fxFlex.gt-sm="10">
              <mat-slide-toggle
                id="deliveryImport"
                formControlName="deliveryImport"
                (change)="toggleDeliveryImport()"
                [disabled]="disableDeliveryImport"
              >
              </mat-slide-toggle>
            </div>
          </div>

          <div [hidden]="isToggleDeliveryImport">
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="100">
                <mat-card class="u-margin-bottom-15" style="padding: 25px;">
                  <mat-card-content
                    *ngFor="let apiDetails of parentForm.get('sotkSettings.sotkDeliveryImportApiDetails')['controls']; let i = index"
                  >
                    <div formArrayName="sotkDeliveryImportApiDetails">
                      <div [formGroupName]="i" fxLayout="row wrap" fxLayoutGap="20px grid">
                        <div fxFlex="80">
                          <div fxFlex="100" fxFlex.gt-sm="30">
                            <mat-label style="text-align: left;">Select Import Provider</mat-label>

                            <mat-form-field id="matFrmFieldProvider">
                              <!-- <mat-label>Please Select</mat-label> -->
                              <mat-select
                                (selectionChange)="changeStokDeliveryImportProvider($event.value,i)"
                                id="matSelectProvider"
                                formControlName="providerControls"
                                [disabled]="action == 'view'"
                              >
                                <mat-option value="">Please Select</mat-option>
                                <mat-option
                                  *ngFor="let provider of deliveryImportProviderOptions[i]"
                                  [value]="provider.value"
                                >
                                  {{ provider.name }}
                                </mat-option>
                              </mat-select>
                              <!-- <mat-error *ngIf="providerControl.hasError('required')"
                              >Please Select Any One
                            </mat-error> -->
                            </mat-form-field>
                          </div>
                        </div>
                        <div fxFlex="20" class="u-text-right">
                          <button
                            style="background-color: transparent;
                        color: #000000;"
                            [disabled]="action=='view'"
                            mat-flat-button
                            color="primary"
                            (click)="deleteSotkDeliveryImportApiDetailContainer(i);"
                          >
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="100">
                          <div *ngIf="enableSotkDeliveryImportBILDetails[i]">
                            <app-rj-provider-details-settings
                              [action]="action"
                              [parentForm]="parentForm"
                              [ebasketRjApiDetails]="sotkDeliveryImportBILDetails"
                              [authControlKey]="'deliveryImportBILDetails'"
                              [sotkModule]="sotkModule"
                            >
                            </app-rj-provider-details-settings>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="timeControlContainer" *ngIf="enableSotkDeliveryImportBILDetails[i]">
                      <div class="timeControlLabel" fxFlex="100" fxLayoutAlign="start">
                        {{ "module-assignment.sotk_settings.frequency" | translate }}
                      </div>
                      <div class="timeControl">
                        <div>
                          <mat-form-field>
                            <mat-label>Select Time Unit</mat-label>
                            <mat-select
                              formControlName="timeUnit"
                              (selectionChange)="updateTimeControl()"
                            >
                              <mat-option *ngFor="let unit of timeUnits" [value]="unit.value">
                                {{ unit.viewValue }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div>
                          <!-- Dropdown for selecting values -->
                          <mat-form-field>
                            <mat-label>Select Value</mat-label>
                            <mat-select formControlName="timeValue">
                              <mat-option *ngFor="let value of values" [value]="value">
                                {{ value }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                  <mat-card-header>
                    <div fxFlex="20" class="u-text-left">
                      <mat-card-title>
                        {{ "organization.create.section_4.add_provider" | translate
                        }}</mat-card-title
                      >
                    </div>
                    <div fxFlex="80" class="u-text-right">
                      <button
                        style="background-color: transparent;
                        color: #000000;"
                        [disabled]="action=='view' || enableDisableAddProvidersDeliveryImport() || isProviderSelectedDeliveryImport()"
                        mat-flat-button
                        color="primary"
                        (click)="openSotkDeliveryImportSelectApiPopup();"
                      >
                        <mat-icon>add_circle_outline</mat-icon>
                        <!-- {{ 'organization.module_assignment_tab.reason_code_tab.add' | translate}} -->
                      </button>
                    </div>
                  </mat-card-header>
                </mat-card>
              </div>
            </div>
          </div>

          <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
            <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
              {{ "module-assignment.sotk_settings.deliveryExport" | translate }}
            </div>
            <div fxFlex="100" fxFlex.gt-sm="10">
              <mat-slide-toggle
                id="deliveryExport"
                formControlName="deliveryExport"
                (change)="toggleDeliveryExport()"
              >
              </mat-slide-toggle>
            </div>
          </div>

          <div [hidden]="isToggleDeliveryExport">
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="100">
                <mat-card class="u-margin-bottom-15" style="padding: 25px;">
                  <mat-card-content
                    *ngFor="let apiDetails of parentForm.get('sotkSettings.sotkDeliveryExportApiDetails')['controls']; let i = index"
                    formArrayName="sotkDeliveryExportApiDetails"
                  >
                    <div [formGroupName]="i" fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="80">
                        <div fxFlex="100" fxFlex.gt-sm="30">
                          <mat-label style="text-align: left;">Select Export Provider</mat-label>

                          <mat-form-field id="matFrmFieldProvider">
                            <!-- <mat-label>Please Select</mat-label> -->
                            <mat-select
                              (selectionChange)="changeStokDeliveryExportProvider($event.value,i)"
                              id="matSelectProvider"
                              formControlName="providerControls"
                              [disabled]="action == 'view'"
                            >
                              <mat-option value="">Please Select</mat-option>
                              <mat-option
                                *ngFor="let provider of deliveryExportProviderOptions[i]"
                                [value]="provider.value"
                              >
                                {{ provider.name }}
                              </mat-option>
                            </mat-select>
                            <!-- <mat-error *ngIf="providerControl.hasError('required')"
                              >Please Select Any One
                            </mat-error> -->
                          </mat-form-field>
                        </div>
                      </div>
                      <div fxFlex="20" class="u-text-right">
                        <button
                          style="background-color: transparent;
                        color: #000000;"
                          [disabled]="action=='view'"
                          mat-flat-button
                          color="primary"
                          (click)="deleteSotkDeliveryExportApiDetailContainer(i);"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>

                      <div fxFlex="100" fxFlex.gt-sm="100">
                        <div *ngIf="enableSotkDeliveryExportBILDetails[i]">
                          <app-rj-provider-details-settings
                            [action]="action"
                            [parentForm]="parentForm"
                            [ebasketRjApiDetails]="sotkDeliveryExportBILDetails"
                            [authControlKey]="'deliveryExportBILDetails'"
                            [sotkModule]="sotkModule"
                          >
                          </app-rj-provider-details-settings>
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                  <mat-card-header>
                    <div fxFlex="20" class="u-text-left">
                      <mat-card-title>
                        {{ "organization.create.section_4.add_provider" | translate
                        }}</mat-card-title
                      >
                    </div>
                    <div fxFlex="80" class="u-text-right">
                      <button
                        style="background-color: transparent;
                        color: #000000;"
                        [disabled]="action=='view' || enableDisableAddProvidersDeliveryExport() || isProviderSelectedDeliveryExport()"
                        mat-flat-button
                        color="primary"
                        (click)="openSotkDeliveryExportSelectApiPopup();"
                      >
                        <mat-icon>add_circle_outline</mat-icon>
                        <!-- {{ 'organization.module_assignment_tab.reason_code_tab.add' | translate}} -->
                      </button>
                    </div>
                  </mat-card-header>
                </mat-card>
              </div>
            </div>
          </div>

          <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
            <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
              {{ "module-assignment.sotk_settings.dispatchExport" | translate }}
            </div>
            <div fxFlex="100" fxFlex.gt-sm="10">
              <mat-slide-toggle
                id="dispatchExport"
                formControlName="dispatchExport"
                (change)="toggleDispatchExport()"
              >
              </mat-slide-toggle>
            </div>
          </div>

          <div [hidden]="isToggleDispatchExport">
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="100">
                <mat-card class="u-margin-bottom-15" style="padding: 25px;">
                  <mat-card-content
                    *ngFor="let apiDetails of parentForm.get('sotkSettings.sotkDispatchExportApiDetails')['controls']; let i = index"
                    formArrayName="sotkDispatchExportApiDetails"
                  >
                    <div [formGroupName]="i" fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="80">
                        <div fxFlex="100" fxFlex.gt-sm="30">
                          <mat-label style="text-align: left;">Select Export Provider</mat-label>

                          <mat-form-field id="matFrmFieldProvider">
                            <!-- <mat-label>Please Select</mat-label> -->
                            <mat-select
                              (selectionChange)="changeStokDispatchExportProvider($event.value,i)"
                              id="matSelectProvider"
                              formControlName="providerControls"
                              [disabled]="action == 'view'"
                            >
                              <mat-option value="">Please Select</mat-option>
                              <mat-option
                                *ngFor="let provider of dispatchExportProviderOptions[i]"
                                [value]="provider.value"
                              >
                                {{ provider.name }}
                              </mat-option>
                            </mat-select>
                            <!-- <mat-error *ngIf="providerControl.hasError('required')"
                              >Please Select Any One
                            </mat-error> -->
                          </mat-form-field>
                        </div>
                      </div>
                      <div fxFlex="20" class="u-text-right">
                        <button
                          style="background-color: transparent;
                        color: #000000;"
                          [disabled]="action=='view'"
                          mat-flat-button
                          color="primary"
                          (click)="deleteSotkDispatchExportApiDetailContainer(i);"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>

                      <div fxFlex="100" fxFlex.gt-sm="100">
                        <div *ngIf="enableSotkDispatchExportBILDetails[i]">
                          <app-rj-provider-details-settings
                            [action]="action"
                            [parentForm]="parentForm"
                            [ebasketRjApiDetails]="sotkDispatchExportBILDetails"
                            [authControlKey]="'dispatchExportBILDetails'"
                            [sotkModule]="sotkModule"
                          >
                          </app-rj-provider-details-settings>
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                  <mat-card-header>
                    <div fxFlex="20" class="u-text-left">
                      <mat-card-title>
                        {{ "organization.create.section_4.add_provider" | translate
                        }}</mat-card-title
                      >
                    </div>
                    <div fxFlex="80" class="u-text-right">
                      <button
                        style="background-color: transparent;
                        color: #000000;"
                        [disabled]="action=='view' || enableDisableAddProvidersDispatchExport() || isProviderSelectedDispatchExport()"
                        mat-flat-button
                        color="primary"
                        (click)="openSotkDispatchExportSelectApiPopup();"
                      >
                        <mat-icon>add_circle_outline</mat-icon>
                        <!-- {{ 'organization.module_assignment_tab.reason_code_tab.add' | translate}} -->
                      </button>
                    </div>
                  </mat-card-header>
                </mat-card>
              </div>
            </div>
          </div>
        </div>

        <!-- <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
          <p style="text-indent: 30pt;">
            {{ "organization.create.section_4.sales_import" | translate }}
          </p>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
            <mat-slide-toggle
              id="matSelectTogglesalesImport"
              formControlName="sotkSettings.salesImport"
              (change)="toggleSalesImport()"
            >
            </mat-slide-toggle>
          </div>
        </div> -->

        <mat-card-header>
          <mat-card-title
            >{{ "module-assignment.sotk_settings.splunkReportsConfiguration" | translate }}
          </mat-card-title>
        </mat-card-header>
        <div fxLayout="row wrap" fxLayoutGap="50px grid">
          <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="start center">
            <mat-form-field class="mat-block">
              <input
                id="appName"
                formControlName="appName"
                [required]="isRequired('appName')"
                matInput
                [placeholder]="
                  'module-assignment.sotk_settings.appName' |
                  translate"
              />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="50px grid">
          <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="start center">
            <mat-form-field class="mat-block">
              <input
                id="userName"
                formControlName="userName"
                [required]="isRequired('userName')"
                matInput
                [placeholder]="
                  'module-assignment.sotk_settings.userName' |
                  translate"
              />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="50px grid">
          <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="start center">
            <mat-form-field class="mat-block">
              <input
                type="password"
                id="password"
                formControlName="password"
                [required]="isRequired('password')"
                matInput
                [placeholder]="
                  'module-assignment.sotk_settings.password' |
                  translate"
              />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="50px grid">
          <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="start center">
            <mat-form-field class="mat-block">
              <input
                id="host"
                formControlName="host"
                [required]="isRequired('host')"
                matInput
                [placeholder]="
                  'module-assignment.sotk_settings.host' |
                  translate"
              />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="50px grid">
          <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="start center">
            <mat-form-field class="mat-block">
              <input
                id="port"
                formControlName="port"
                [required]="isRequired('port')"
                matInput
                [placeholder]="
                  'module-assignment.sotk_settings.port' |
                  translate"
              />
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
          <div>
            <mat-checkbox
              id="addReportBtn"
              formControlName="addReportBtn"
              (change)="addReportBtnChecked($event)"
            >
            </mat-checkbox>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="20" fxLayoutAlign="start center">
            {{ "module-assignment.sotk_settings.addReportBtn" | translate }}
          </div>
        </div>

        <table
          id="matTableException"
          mat-table
          [dataSource]="exceptionDataSource"
          formArrayName="reportButton"
          *ngIf="getIsAddBtnEnabledValue()"
        >
          <tr id="matHeaderRowException" mat-header-row *matHeaderRowDef="execeptionColumns"></tr>
          <tr id="matRowException" mat-row *matRowDef="let row; columns: execeptionColumns"></tr>

          <ng-container matColumnDef="buttonName">
            <th mat-header-cell *matHeaderCellDef>
              <button
                id="btnAddNewException"
                type="button"
                mat-icon-button
                matTooltipPosition="above"
                (click)="addButtonRow()"
                [disabled]="action=='view'"
              >
                <mat-icon>add_box</mat-icon>
              </button>
            </th>

            <td mat-cell *matCellDef="let exception; let index = index" [formGroupName]="index">
              <mat-form-field id="matFrmFieldFromDate{{index}}" class="mat-block">
                <input
                  id="txtFromDate{{index}}"
                  matInput
                  formControlName="buttonName"
                  [placeholder]="'module-assignment.sotk_settings.buttonName' | translate"
                  [required]="isRequired('buttonName')"
                  [disabled]="action === 'view'"
                />
                <mat-error class="error-message" *ngIf="checkBtnLength('buttonName')">
                  <span>
                    {{ "module-assignment.sotk_settings.report_btn_size" | translate }}
                  </span>
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="savedSearchName">
            <th mat-header-cell *matHeaderCellDef></th>

            <td mat-cell *matCellDef="let exception; let index = index" [formGroupName]="index">
              <mat-form-field id="matFrmFieldFromDate{{index}}" class="mat-block">
                <input
                  id="txtFromDate{{index}}"
                  matInput
                  formControlName="savedSearchName"
                  [placeholder]="'module-assignment.sotk_settings.savedSearchName' | translate"
                  [required]="isRequired('savedSearchName')"
                  [disabled]="action === 'view'"
                />
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="deleteBtn">
            <th mat-header-cell *matHeaderCellDef style="width: 124px;">
              <!-- {{'module-assignment.sotk_settings.action' | translate}} -->
            </th>
            <td mat-cell *matCellDef="let exception; let index = index">
              <button
                id="btnDeleteException"
                mat-icon-button
                matTooltipPosition="above"
                [matTooltip]="'module-assignment.sotk_settings.delete' | translate"
                (click)="deleteBtnRow(index);"
                [disabled]="action === 'view'"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
</div>
